import { createRouter, createWebHistory } from 'vue-router';


import Generator from '../views/Generator.vue';


const routes = [
    {
        path: '/',
        name: 'Generator',
        component: Generator,
        meta: {
            title: 'QR Code Generator'
        }
    },
    {
        name: 'History',
        path: '/history',
        description: 'View past generations',
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('../views/About.vue'),
        meta: {
            title: 'About'
        }
    },
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL), // Updated for Vite
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    }
})

// Navigation guards
router.beforeEach((to, from, next) => {
    // Update page title
    document.title = `${to.meta.title} | QR Code Generator`
    next()
})

export default router;